<!-- TEMPLATE -->
<template>
  <div>
    <b-table
      v-if="fields.length > 0"
      ref="table"
      id="my-table"
      :items="dataItems"
      :fields="fields"
    >

      <template v-slot:cell()="data">
        <div v-if="data.value.type === ProductType.LABEL">
          <b>{{ data.value.value }}</b>
        </div>

        <div v-if="data.value.type === ProductType.DATE">
          <wish-date
              :label="data.field.label"
              v-model="data.value.value"
              :productId="data.value.productId"
              :hide-as-soon-as-possible-option="isMobilePortingNumberTracker[data.index]"
              :selected-mobile-number-porting="isMobilePortingNumberTracker[data.index]"
              :porting-contract-handling="portingContractHandlingTracker[data.index]"
          ></wish-date>
        </div>

        <div v-if="data.value.type === ProductType.PHONE_NUMBER">
          <dean-input-field
              type="text"
              :disabled="
                disabledField(data.index, data.value)
                || (
                    data.value.name === 'tmlOldNumber'
                    && (
                        data.value.disable === undefined
                        || data.value.disable === true
                    )
                )"
              v-model="data.value.value"
          >
            <slot>{{ data.field.label }}</slot>
          </dean-input-field>
        </div>

        <div v-if="data.value.type === ProductType.BOOLEAN">
          <dean-input-switch @checked="valueSwitched($event, data.index, data.field.key)"
                             :checked="data.value.value"
          ></dean-input-switch>
        </div>

        <div v-if="data.value.type === ProductType.PORTING">
          <dean-input-switch @checked="valueSwitched($event, data.index, data.field.key)"
                             :checked="data.value.value"
          ></dean-input-switch>
        </div>

        <div v-if="data.value.type === ProductType.CONTRACTED_SERVICE">
          <dean-input-switch v-if="data.value.limit == 1"
                             @checked="valueSwitched($event, data.index, data.field.key)"
                             :checked="data.value.value"
          ></dean-input-switch>
        </div>

        <div v-if="data.value.type === ProductType.STRING">
          <dean-input-field
            type="text"
            :disabled="disabledField(data.index, data.value)"
            v-model="data.value.value"
          >
            <slot>{{ data.field.label }}</slot>
          </dean-input-field>
        </div>

        <div v-if="data.value.type === ProductType.SIM_NUMBER">
          <sim-number-search
              :partnerCode="partnerCode"
              :customerId="customerId"
              :searchType="data.value.simType"
              :searchProvider="data.value.simProvider"
              :disabled="disabledField(data.index, data.value)"
              v-model="data.value.value"
              @simNumberSelected="setSimNumber($event, data.value, data.value.name, data.index)">
          </sim-number-search>
        </div>

        <div v-if="data.value.type === ProductType.ADDRESS">
          <dean-select-form-row
              id="address" placeholder="kies een adres" key="address"
              :required-field="true" :hide-label="true"
              :options="addressList"
              @input="valueChanged($event, data.index, data.field.key)"
              :clearable="true">
          </dean-select-form-row>
        </div>

        <div v-if="data.value.type === ProductType.DROPDOWN">
          <dean-select-form-row
              :value="currentlySelectedOption(data.value.value, data.value.options)"
              :options="data.value.options"
              :hideLabel="true"
              :clearable="false"
              :disabled="disabledField(data.index, data.value)"
              @input="data.value.value = $event">
          </dean-select-form-row>
          <p v-html="dropdownInfoText(
              data.value.name,
              data.value.value,
              data.value.options,
              disabledField(data.index, data.value)
            )"></p>
        </div>
      </template>
    </b-table>

    <b-table
      v-if="extraItems.length > 0"
      v-for="(item, index) in extraItems"
      v-bind:key="index"
      ref="extraProductTables"
      id="second-table"
      :items="extraItems[index]"
      :fields="extraFields[index]"
    >
      <template slot="thead-top">
        <tr>
          <th :colspan="extraFields[index].length">
            {{ extraFields[index][0].label.toUpperCase() }}
          </th>
        </tr>
      </template>

      <template v-slot:cell()="data">
        <div v-if="data.value.type === ProductType.STRING">
          <dean-input-field
              type="text"
              :disabled="disabledExtraItem(index, data.value)"
              v-model="data.value.value"
          >
            <slot>{{ data.field.label }}</slot>
          </dean-input-field>
        </div>

        <div v-if="data.value.type === ProductType.PHONE_NUMBER">
          <dean-input-field
              type="text"
              :disabled="
                disabledExtraItem(index, data.value)
                || data.value.name === 'tmlOldNumber'
                || (
                    data.value.name === 'tmlCopyNumber'
                    && (
                        data.value.disable === undefined
                        || data.value.disable === true
                    )
                )
                || (
                    data.value.name === 'tmlCopyNumber2'
                    && (
                        data.value.disable === undefined
                        || data.value.disable === true
                    )
                )"
              v-model="data.value.value"
          >
            <slot>{{ data.field.label }}</slot>
          </dean-input-field>
        </div>

        <div v-if="data.value.type === ProductType.DATE">
          <wish-date
              :label="data.field.label"
              v-model="data.value.value"
          ></wish-date>
        </div>

        <div v-if="data.value.type === ProductType.BOOLEAN">
          <dean-input-switch @checked="extraFieldValueSwitched($event, index, data.field.key)"
                             :checked="data.value.value"
          ></dean-input-switch>
        </div>

        <div v-if="data.value.type === ProductType.SIM_NUMBER">
          <sim-number-search
              :customerId="customerId"
              :partnerCode="partnerCode"
              :searchType="data.value.simType"
              :searchProvider="data.value.simProvider"
              v-model="data.value.value"
              :disabled="disabledExtraItem(index, data.value)"
              @simNumberSelected="setSimNumber($event, data.value, data.value.name, index)">
          </sim-number-search>
        </div>

        <div v-if="data.value.type === ProductType.DROPDOWN">
          <dean-select-form-row
              :value="currentlySelectedOption(data.value.value, data.value.options)"
              :options="data.value.options"
              :hideLabel="true"
              :clearable="false"
              :disabled="false"
              @input="handleDropdownChange($event, data.value, index)">
          </dean-select-form-row>
          <p v-html="dropdownInfoText(
              data.value.name,
              data.value.value,
              data.value.options,
              false,
          )"></p>
        </div>
      </template>
    </b-table>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
import ToolsMixin from '@/mixins/toolsMixin';
import {BTable, BTooltip} from 'bootstrap-vue';
import axios from 'axios';
import {
  deanButton,
  deanIcon,
  deanLoadOverlay,
  deanSectionDivider,
  deanSectionTitle,
  deanSectionTitleItem,
  forwardIcon,
  infoIcon,
  plusIcon,
  trashIcon,
} from '@deanone/dean-components';
import DeanInputField from '@/components/deanComponents/deanInputField.vue';
import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import DeanInputSwitch from '@/components/deanComponents/deanInputSwitch.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import WishDate from '@/components/quote/wishDate.vue';
import SimNumberSearch from '@/components/quote/simNumberSearch.vue';
import {validationMessage} from '@/mixins/validations';
import DateInput from '@/components/DateInput.vue';
import {SimType} from "@/enums/SimType";
import {ProductType} from "@/enums/ProductType";
import {ServiceTypeEnum} from "@/enums/ServiceTypeEnum";
import {PortingContractHandling} from "@/enums/PortingContractHandling";
import {getButtonLabel} from "@/mixins/buttonTranslation";

@Component({
  computed: {
    ProductType() {
      return ProductType
    }
  },
  components: {
    deanIcon,
    plusIcon,
    infoIcon,
    deanButton,
    trashIcon,
    deanFormRow,
    deanSectionTitle,
    deanSectionDivider,
    deanSectionTitleItem,
    forwardIcon,
    deanLoadOverlay,
    BTable,
    DeanInputField,
    DeanInputSwitch,
    DeanSelectFormRow,
    WishDate,
    SimNumberSearch,
    BTooltip,
    DateInput,
  },
  mixins: [
    ToolsMixin,
  ],
})

export default class InputTable extends Vue {
  @Prop({}) public serviceType!: ServiceTypeEnum|null;
  @Prop({}) public data!: any;
  @Prop({}) public payloadData!: any;
  @Prop({}) public productTitle!: string;
  public addressList: any = [];
  public customerId: string = '';
  public partnerCode: string = '';
  public isMobilePortingNumberTracker: Array<boolean> = [];
  public portingContractHandlingTracker: Array<string | null> = [];
  public serviceTypesRequiringNumeration: Array<ServiceTypeEnum> = [
    ServiceTypeEnum.MOBILE_ODIDO,
    ServiceTypeEnum.MOBILE_KPN,
  ];

  get extraItems() {
    const extraItems: any = [];
    let field = null;

    if (!this.data || !Array.isArray(this.data)) {
      return extraItems;
    }

    this.data.forEach((row: any, rowIndex: number) => {
      if (!row || typeof row !== 'object') {
        return;
      }

      for (const fieldName of Object.keys(row)) {
        if (row[fieldName].type === ProductType.CONTRACTED_SERVICE) {
          field = row[fieldName];
          const fieldLabelName = this.getFieldLabel(rowIndex, fieldName);

          if (field && field.fields) {
            const count = field.value;

            while (field.fields.length < count ) {
              const copy = JSON.parse(JSON.stringify(field.rules));

              field.fields.push(copy);
            }

            for (let i = 0; i < count; i++) {
              const item = [fieldLabelName, row.tmlOldNumber, ...field.fields[i]];

              extraItems.push([item]);
            }
          }
        } else if (row[fieldName].type === ProductType.SUB_ARRAY) {
          const fieldLabelName = this.getFieldLabel(rowIndex, fieldName);

          field = row[fieldName];

          if (field && field.rules) {
            if (!field.condition) {
              field.rules.forEach((subItem: any) => {
                extraItems.push([subItem]);
              });
            }
            else if (row[this.normalizeConditionName(field.condition)] && this.condition(rowIndex, field.condition)) {
              const item = [fieldLabelName, ...field.rules];

              extraItems.push([item]);
            }
          }
        } else if (row[fieldName].type === ProductType.PORTING) {
          const fieldLabelName = this.getFieldLabel(rowIndex, fieldName);

          const portingItems = [];

          for (const fieldNamePorting of Object.keys(row)) {
            if (row[fieldNamePorting].condition !== 'isPorting') {
              continue;
            }

            portingItems.push(row[fieldNamePorting]);
          }

          let item;

          if (row.tmlOldNumber) {
            item = [fieldLabelName, row.tmlOldNumber, ...portingItems];
          } else {
            item = [fieldLabelName, ...portingItems];
          }

          if (row[fieldName].value === true) {
            extraItems.push([item]);
          }
        }
      }
    });

    return extraItems;
  }

  get extraFields() {
    const extraFields = [];

    for (const elements of (this.extraItems as any)) {
      const itemFields = [];

      for (const value of Object.keys(elements)) {
        if (elements[value][0] && elements[value][0]['label']) {
          itemFields.push({
            key: elements[value][0]['key'],
            label: elements[value][0]['label'],
          });
        }

        for (const data of Object.keys(elements[value])) {
          if (data === 'type') {
            itemFields.push({
              key: null,
              label: elements[value][data].type,
            });
          }

          if (
            elements[value][data]?.name
            && data !== 'type'
          ) {
            itemFields.push({
              key: data,
              label: getButtonLabel(elements[value][data].name),
            });
          }
        }
      }

      extraFields.push(itemFields);
    }

    return extraFields;
  }

  get dataItems() {
    if (!this.data || !Array.isArray(this.data) || this.data.length === 0) {
      return [];
    }

    return this.data.map((elements: any, index: number) => {
      const row: any = {};
      
      // Copy all existing properties
      Object.keys(elements).forEach(key => {
        row[key] = elements[key];
      });
      
      // Add numeration if needed
      if (this.showNumeration()) {
        row['no'] = {
          name: 'no',
          type: ProductType.LABEL,
          value: '#' + (index + 1).toString()
        };
      }

      return row;
    });
  }

  get fields(): Array<{ key: string; label: string }> {
    const fields: Array<{ key: string; label: string }> = [];
    const processedKeys = new Set();

    // Only process the first data item to build fields
    if (this.data.length === 0) {
      return fields;
    }

    const elements = this.data[0];

    if (this.showNumeration()) {
      fields.push({
        key: 'no',
        label: 'No.',
      });
    }

    for (const value in elements) {
      if (
          elements[value] &&
          elements[value].name
          && elements[value].type !== ProductType.SUB_ARRAY
          && elements[value].condition !== 'isPorting'
          && !processedKeys.has(value)
      ) {
        processedKeys.add(value);

        let elementValue = elements[value].name;
        // modify label name because tmlOldNumber can be 06 and 097 depending on sim type (8 (voice), 9(data))
        if (elements[value].name === 'tmlOldNumber') {
          const simNumberField = 'simNumber';

          if (!elements[simNumberField] || !elements[simNumberField].hasOwnProperty('simType')) {
            console.warn(`Warning: simType field is missing for element with value: ${value} and ${simNumberField}.`);
          } else {
            if (elements[simNumberField].simType === SimType.VOICE) {
              elementValue = 'tmlOldNumberType8';
            }

            else if (elements[simNumberField].simType === SimType.DATA) {
              elementValue = 'tmlOldNumberType9';
            }
          }
        }

        fields.push({
          key: value,
          label: getButtonLabel(elementValue),
        });
      }
    }

    return fields;
  }

  public showNumeration(): boolean {
    if (this.serviceType && this.serviceTypesRequiringNumeration.includes(this.serviceType)) {
      return true;
    }

    return false;
  }

  public dropdownInfoText(type: any, value: any, options: any, disabled: boolean) {
    if (disabled) {
      return;
    }

    const optionKey: any = this.currentlySelectedOptionKey(value, options);

    if (null === optionKey) {
      return;
    }

    const dropdownInfoText: any = this.$t('dropdownInfoText.' + type);

    if (
        '' === dropdownInfoText
        || undefined === dropdownInfoText
    ) {
      return;
    }

    return '<i>' + dropdownInfoText[optionKey].join(' ') + '</i>';
  }

  public currentlySelectedOption(value: any, options: any) {
    if (value !== null) {
      const foundKey = this.currentlySelectedOptionKey(value, options);

      return foundKey != null ? options[foundKey] : null;
    }

    return null;
  }

  public currentlySelectedOptionKey(value: any, options: any) {
    if (value !== null) {
      const foundKey = Object.keys(options).find((key) => options[key] === value);
      return foundKey != null ? foundKey : null;
    }

    return null;
  }

  public handleDropdownChange(event: any, dataValue: any, rowIndex: number): void {
    dataValue.value = event;

    const parentRowIndex = this.extraItems[rowIndex]?.[0]?.[0]?.key;
    
    if (dataValue.name === 'portingCurrentContract' && parentRowIndex >= 0) {
      this.setPortingContractHandlingTracker(parentRowIndex);
    }
  }

  public mounted() {
    this.$emit('setLoad', true);

    const promises = [];

    this.customerId = this.payloadData.customerId;
    promises.push(this.getAddressList(this.payloadData.partnerId));
    promises.push(this.getAddressList(this.payloadData.customerId));
    promises.push(this.getPartnerCode());

    Promise.all(promises).finally(() => this.$emit('setLoad', false));

    for (let i = 0; i < this.data.length; i++) {
      this.setMobilePortingNumberTracker(i);
      this.setPortingContractHandlingTracker(i);
    }
  }

  public disabledField(rowIndex: number, value: any): boolean {
    if (value.disabled === true) {
      return true;
    }

    if (value.condition && !this.condition(rowIndex, value.condition)) {
      value.value = '';

      return true;
    }

    return false;
  }

  public disabledExtraItem(rowIndex: number, value: any): boolean {
    if (value.disabled === true) {
      return true;
    }

    if (value.condition && !this.extraItemCondition(rowIndex, value.condition)) {
      value.value = '';

      return true;
    }

    return false;
  }

  public condition(rowIndex: number, conditionName: string): boolean {
    const isNegated: boolean = conditionName.startsWith('!');

    const normalizedConditionName: string = this.normalizeConditionName(conditionName);

    const conditionValue = this.data[rowIndex][normalizedConditionName]?.value;

    return isNegated ? !conditionValue : conditionValue;
  }

  public extraItemCondition(rowIndex: number, conditionName: string): boolean {
    const isNegated: boolean = conditionName.startsWith('!');

    const normalizedConditionName: string = this.normalizeConditionName(conditionName);

    const items = this.extraItems[rowIndex]?.[0];

    if (!Array.isArray(items)) {
      return true;
    }

    const item = items.find(
        (obj: any) => obj && typeof obj === 'object' && obj.name === normalizedConditionName
    );

    if (item === undefined) {
      return true;
    }

    const conditionValue = item.value;

    return isNegated ? !conditionValue : conditionValue;
  }

  public normalizeConditionName(conditionName: string): string {
    return conditionName?.replace('!', '');
  }

  public getFieldLabel(rowIndex: number, fieldName: string): { key: number; label: string; } {
    let label: string = getButtonLabel(fieldName);

    if (this.showNumeration()) {
      label = `#${rowIndex + 1} ${label}`;
    }

    return {
      key: rowIndex,
      label: `${label}`,
    };
  }

  public getAddressList(personId: any) {
    const url = '/-/trade/api/person.addresses.list';
    const requestData = {
      id: personId,
    };

    return axios.post(url, requestData).then(
      (response) => {
        response.data.map((address: any) => {
          const addressHouseNumberExtension: string = (address.houseNumberExtension
              ? '/' + address.houseNumberExtension : '');
          const addressHouseNumber: string = address.houseNumber + addressHouseNumberExtension;
          const addressLabel: string = `${address.street} ${addressHouseNumber}, ${address.city}`;

          this.addressList.push({
            value: address.id,
            label: addressLabel,
          });
        });
      },
      (error) => {
        this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
      },
    );
  }

  public getPartnerCode() {
    if (
      this.$store.getters.getUser.organization
      && this.$store.getters.getUser.organization.isProvider
    ) {
      return axios
        .post('/-/trade/api/partner.info', {
          id: this.payloadData.partnerId,
        }).then(
          (response: any) => {
            this.partnerCode = response.data.code;
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        });
    } else {
      this.partnerCode = this.$store.getters.getUser.organization.code;
    }
  }

  public extraFieldValueSwitched(field: any, rowIndex: number, key: any) {
    this.extraItems[rowIndex][0][key].value = !this.extraItems[rowIndex][0][key].value;

    this.refreshExtraProductTables();
  }

  public valueSwitched(field: any, index: any, key: any) {
    this.data[index][key].value = !this.data[index][key].value;

    if (this.data[index][key].limit_groups) {
      const limit_groups = this.data[index][key].limit_groups;

      Object.keys(this.data[index]).forEach((iter: any) => {
        if (
            iter !== key
            && this.data[index][iter].limit_groups
            && this.data[index][iter].limit_groups.some((group: any) =>
                limit_groups.includes(group)
            )
        ) {
          this.data[index][iter].value = false;
        }
      });
    }

    if (key === 'isPorting') {
      this.setMobilePortingNumberTracker(index);
    }
  }

  public setMobilePortingNumberTracker(index: number, key: string = 'isPorting'): void {
    let mobilePortingTracker = this.isMobilePortingNumberTracker || [];

    if (!this.data[index][key]) {
      return;
    }

    mobilePortingTracker[index] = this.data[index][key].value

    this.isMobilePortingNumberTracker = mobilePortingTracker;
  }

  public setPortingContractHandlingTracker(parentIndex: number): void {
    let portingContractHandlingTracker = this.portingContractHandlingTracker || [];

    let portingCurrentContract: any|null = null;

    const extraItemIndex = this.extraItems.findIndex((item: any[]) =>
        Array.isArray(item[0]) && item[0][0]?.key === parentIndex
    );

    if (extraItemIndex !== -1 && this.extraItems[extraItemIndex][0].find((item: any) => item && item.name === 'portingCurrentContract')) {
      portingCurrentContract = this.extraItems[extraItemIndex][0].find((item: any) => item && item.name === 'portingCurrentContract');
    }

    if (portingCurrentContract && portingCurrentContract.value) {
      const enumKey = PortingContractHandling.tryFrom(portingCurrentContract.value);

      this.portingContractHandlingTracker[parentIndex] = enumKey;
      this.$set(this.portingContractHandlingTracker, parentIndex, enumKey);
    } else {
      this.portingContractHandlingTracker[parentIndex] = null;
      this.$set(this.portingContractHandlingTracker, parentIndex, null);
    }

    this.portingContractHandlingTracker = portingContractHandlingTracker;
  }

  public valueChanged(field: any, index: any, key: any) {
    this.data[index][key].value = field.value;
  }

  public setSimNumber(newSimNumber: any, oldSimNumber: any, fieldName: any, index: any) {
    oldSimNumber.value = newSimNumber.simNumber;

    if (
      newSimNumber.searchType === SimType.VOICE
      && this.data[index].tmlOldNumber !== undefined
    ) {
      this.data[index].tmlOldNumber.value = newSimNumber.tmlNumber;
      this.data[index].tmlOldNumber.disable = newSimNumber.disableTmlField;
    }

    else if (newSimNumber.searchType === SimType.DATA) {
      if (
        this.data[index].tmlCopyNumber === undefined
        && this.data[index].tmlOldNumber !== undefined
      ) {
        this.data[index].tmlOldNumber.value = newSimNumber.tmlNumber;
        this.data[index].tmlOldNumber.disable = newSimNumber.disableTmlField;
      }

      if (
        this.data[index].tmlOldNumber === undefined
        && this.data[index].tmlCopyNumber !== undefined
      ) {
        this.data[index].tmlCopyNumber.value = newSimNumber.tmlNumber;
        this.data[index].tmlCopyNumber.disable = newSimNumber.disableTmlField;
      }
    }

    else if (newSimNumber.searchType === SimType.MB_SHARING) {
      const tmlCopyNumber = this.extraItems[index][0].find((item: any) => item.name === 'tmlCopyNumber');
      const tmlCopyNumber2 = this.extraItems[index][0].find((item: any) => item.name === 'tmlCopyNumber2');

      if (fieldName === 'simNumber') {
        if (
          tmlCopyNumber2 !== undefined
          && newSimNumber.tmlNumber !== null
          && tmlCopyNumber2.value === newSimNumber.tmlNumber
        ) {
          this.duplicateNumberErrorMessage();
          return;
        }

        tmlCopyNumber.disable = newSimNumber.disableTmlField;
        tmlCopyNumber.value = newSimNumber.tmlNumber;
      }

      if (fieldName === 'simNumber2') {
        if (
          newSimNumber.tmlNumber !== null
          && tmlCopyNumber.value === newSimNumber.tmlNumber
        ) {
          this.duplicateNumberErrorMessage();

          return;
        }

        tmlCopyNumber2.disable = newSimNumber.disableTmlField;
        tmlCopyNumber2.value = newSimNumber.tmlNumber;
      }

      this.refreshExtraProductTables();
    }
  }

  public refreshExtraProductTables() {
    for (const extraProductsTable of (this.$refs.extraProductTables as any)) {
      (extraProductsTable as any).refresh();
    }
  }

  public duplicateNumberErrorMessage() {
    return this.$toast(
        validationMessage('Kan niet twee keer hetzelfde T-Mobile 0907-nummer selecteren. Kies een ander simkaartnummer.')
    );
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

</style>
